import React from "react";
import styles from "./LanguageSwitch.module.scss";
import { languages, t } from "../../../helpers/translate.helper";
import { cx } from "../../../helpers/ClassNames.helper";

const LanguageSwitch = ({ selected, onSelect }) => (
	<div className={styles.host}>
		{
			languages.map(lang =>
				<div
          key={lang}
					className={cx(
						styles.lang,
						selected === lang && styles.selected
					)}
					onClick={() => onSelect(lang)}
				>
					<img src={`./flags/${lang}.png`} alt={`${t(`lang.${lang}`)} Flag`} />
					{t(`lang.${lang}`)}
				</div>
			)
		}
	</div>
);

export default LanguageSwitch;
